import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Emty from "../../components/Emty/Emty";
import ListSearchSection from "../../components/ListSearchSection/ListSearchSection";
import PostListSection from "../../components/PostListSection/PostListSection";
import UseProjectCommon from "../../hooks/UseProjectCommon";

/** 모집마감 프로젝트 */
function FinishList() {
  const category = useLocation().pathname.split("/")[1] as "prjt" | "mtup";
  const [data, ProjectDelete, SearchProject, ProjectPause, ChangeProjectSts] =
    UseProjectCommon({
      type: category,
      filter:
        "&prjt_sts_cd=prjt_sts_rcrt_end,prjt_sts_ing,prjt_sts_end&prjt_sort_order=rcrt",
      time: "",
    });

  return (
    <main className="finishlist">
      <div className="wrapper">
        <ListSearchSection
          title={`모집마감 ${category === "prjt" ? "프로젝트" : "밋업"}`}
          placeholder={category === "prjt" ? "프로젝트 검색" : "밋업명 검색"}
          isExel={false}
          filter={[]}
          Search={SearchProject}
        />
        {data.length > 0 ? (
          <PostListSection
            type={category === "mtup" ? "finish" : "prjt-finish"}
            tags={category === "mtup" ? mtup_layout : prjt_layout}
            data={data}
            PostRemove={ProjectDelete}
            ProjectPause={undefined}
            category={undefined}
            ChangeProjectSts={ChangeProjectSts}
            __ChangeState={undefined}
            prjtData={undefined}
          />
        ) : (
          <Emty />
        )}
      </div>
    </main>
  );
}

export default FinishList;

const mtup_layout = [
  {
    type: "finish-category",
    title: "분류",
  },
  {
    type: "finish-title",
    title: "밋업명",
  },
  {
    type: "finish-time",
    title: "모집마감일",
  },
  {
    type: "finish-leader",
    title: "팀플리더",
  },
  {
    type: "finish-num",
    title: "모집인원",
  },
];
const prjt_layout = [
  {
    type: "prjt-finish-title",
    title: "프로젝트명",
  },
  {
    type: "finish-time",
    title: "모집마감일",
  },
  {
    type: "finish-leader",
    title: "팀플리더",
  },
  {
    type: "finish-num",
    title: "모집인원",
  },
  {
    type: "prjt-finish-state",
    title: "상태",
  },
];
